







































import { computed, defineComponent } from '@vue/composition-api';
import type { PropType } from '@vue/composition-api';
import { EditorNodeEmptyState } from '@getaccept/editor-lib';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import type { DsrResource } from '@getaccept/lib-shared/src/library/types/dsr-resource';
import type { MappedContentPlaceholder } from '@getaccept/editor-lib/src/types/mapped-content-placeholder';
import type {
  ContentPlaceholder,
  ContentPlaceholderPayload,
} from '@getaccept/editor-lib/src/types/models';

export default defineComponent({
  components: {
    EditorNodeEmptyState,
  },
  props: {
    node: {
      type: Object as PropType<ContentPlaceholder>,
      required: true,
    },
    placeholder: {
      type: Object as PropType<MappedContentPlaceholder>,
      default: () => ({}),
    },
  },
  setup(props) {
    const hasPlaceholder = computed(
      () => !!(props.node.placeholder as ContentPlaceholderPayload)?.resourceIds?.length
    );
    const emptyStateDescription = computed(() =>
      hasPlaceholder.value ? null : t('content_placeholder_is_empty_view_only')
    );
    const isResourceUnavailable = (
      resource: DsrResource | Pick<DsrResource, 'id' | 'title' | 'contentId'>
    ) => {
      const isDeleted = 'deletedAt' in resource && resource.deletedAt !== null;
      const isContentIdMissing = !resource.contentId;
      return isDeleted || isContentIdMissing;
    };

    return {
      t,
      hasPlaceholder,
      emptyStateDescription,
      isResourceUnavailable,
    };
  },
});
